import React, { useEffect, useState } from "react";
import { CrudModal } from "../../components/_index";
import { Formik, Form, Field } from "formik";
import Grid from "@mui/material/Grid2";
import { Typography, Button, Box } from "@mui/material";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { AutoComplete, DatePicker } from "../../components/_index";
import { showToast } from "../../redux/Reducer/toastReducer";
import {
    postHrAdminWork,
    updateHrAdminWork,
} from "../../services/hrAndAdminWork.service";
import { getRole } from "../../services/category.service";
import { getUser, getUsersByRole, getHrAdminAccountsUsers } from "../../services/user.service";
import { getEmail } from "../../services/email.service";
import moment from "moment";


const AddHrAndAdminWork = ({
    handleCloseDrawer,
    formType,
    selectedData,
    setOpenDrawer,
    GetHrAdminWorkData,
}) => {
    const dispatch = useDispatch();
    const disabled = formType === "view";
    const [departmentData, setDepartmentData] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [allUsersData, setAllUsersData] = useState([]);

    const [initialValues, setInitialValues] = useState({
        task: "",
        Department: "",
        incharge: "",
        targetDateToComplete: null,
        emailUsers: [],
        // completedDate: null,
        // remarks: "",
    });

    const validationSchema = yup.object().shape({
        task: yup.string().required("Task is required *"),
        Department: yup.string().required("Department is required *"),
        incharge: yup.string().required("Incharge is required *"),
        targetDateToComplete: yup.date().nullable().required("Target Date is required *"),
    });

    useEffect(() => {
        if (formType === "edit" || formType === "view") {
            setInitialValues({
                task: selectedData.task || "",
                Department: selectedData.Department || "",
                incharge: selectedData.incharge || "",
                targetDateToComplete: selectedData.targetDateToComplete ? moment(selectedData.targetDateToComplete).toDate() : null,
                emailUsers: selectedData.emailUsers || [],
                // completedDate: selectedData.completedDate ? moment(selectedData.completedDate).toDate() : null,
                // remarks: selectedData.remarks || "",
            });
            if (selectedData.Department) {
                getUsers(selectedData.Department);
            }
        }
    }, [formType, selectedData]);

    const onSubmit = async (values) => {
        try {
            const apiMethod =
                formType === "edit"
                    ? updateHrAdminWork(selectedData._id, values)
                    : postHrAdminWork(values);
            const res = await apiMethod;
            setOpenDrawer(false);
            GetHrAdminWorkData();
            dispatch(showToast({ message: res.message, type: "success" }));
        } catch (error) {
            dispatch(showToast({ message: error?.data?.message || "Something went wrong", type: "error" }));
        }
    };

    const getDepartments = async () => {
        try {
            const res = await getRole({ isHrAdminWork: true });
            if (res?.data) {
                const modData = res.data.map(d => ({ ...d, label: d.name, id: d._id }));
                setDepartmentData(modData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getUsers = async (roleId) => {
        if (!roleId) return;
        try {
            const res = await getUsersByRole(roleId);
            let users = [];
            if (res?.data && Array.isArray(res.data)) {
                users = res.data;
            } else if (res?.data?.data && Array.isArray(res.data.data)) {
                users = res.data.data;
            } else if (Array.isArray(res)) {
                // Fallback if interceptor returns array directly (unlikely)
                users = res;
            }

            if (users.length > 0) {
                const modData = users.map(u => ({
                    ...u,
                    label: u.name,
                    id: u._id,
                    _id: u._id // Ensure _id is explicitly present for AutoComplete
                }));
                setUsersData(modData);
            } else {
                setUsersData([]);
            }
        } catch (error) {
            console.log(error);
            setUsersData([]);
        }
    };

    const getAllUsers = async () => {
        try {
            const res = await getEmail();
            if (res?.data) {
                const modData = res.data.map(u => ({
                    ...u,
                    label: u.userData?.name || "N/A",
                    id: u.userId, // This is the ObjectId of the user from the email model
                    _id: u.userId
                }));

                setAllUsersData(modData);
            }
        } catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
        getDepartments();
        getAllUsers();
    }, []);

    return (
        <CrudModal
            title={
                formType === "add"
                    ? "Add Work"
                    : formType === "edit"
                        ? "Edit Work"
                        : "View Work"
            }
            open={true}
            handleClose={handleCloseDrawer}
            maxWidth="md">
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
                enableReinitialize>
                {({ touched, errors, setFieldValue, values }) => (
                    <div className="formContainer" style={{ height: "fit-content" }}>
                        <Form>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                                        Task
                                    </Typography>
                                    <Field
                                        name="task"
                                        className="InputField"
                                        placeholder="Enter Task"
                                        disabled={disabled}
                                    />
                                    <div className="form-error">
                                        {touched.task && errors.task ? errors.task : null}
                                    </div>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                                        Department
                                    </Typography>
                                    <AutoComplete
                                        options={departmentData}
                                        value={values.Department}
                                        getOptionLabel={(option) => option.label}
                                        onChange={(e, v) => {
                                            setFieldValue("Department", v?.id || "");
                                            setFieldValue("incharge", "");
                                            if (v?.id) {
                                                getUsers(v.id);
                                            } else {
                                                setUsersData([]);
                                            }
                                        }}
                                        placeholder="Select Department"
                                        disabled={disabled}
                                    />
                                    <div className="form-error">
                                        {touched.Department && errors.Department ? errors.Department : null}
                                    </div>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                                        Incharge
                                    </Typography>
                                    <AutoComplete
                                        options={usersData}
                                        value={values.incharge}
                                        getOptionLabel={(option) => option.label}
                                        onChange={(e, v) => {
                                            setFieldValue("incharge", v?.id || "");
                                        }}
                                        placeholder="Select Incharge"
                                        disabled={disabled}
                                    />
                                    <div className="form-error">
                                        {touched.incharge && errors.incharge ? errors.incharge : null}
                                    </div>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                                        Target Dates
                                    </Typography>
                                    <DatePicker
                                        value={values.targetDateToComplete}
                                        onChange={(v) => setFieldValue("targetDateToComplete", v)}
                                        placeholder="Select Target Date"
                                        disabled={disabled}
                                        disablePast={true}
                                        clearable={false}
                                    />
                                    <div className="form-error">
                                        {touched.targetDateToComplete && errors.targetDateToComplete
                                            ? errors.targetDateToComplete
                                            : null}
                                    </div>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                                        Email Users
                                    </Typography>
                                    <AutoComplete
                                        multiple
                                        options={allUsersData}
                                        value={values.emailUsers}


                                        getOptionLabel={(option) => option.label}
                                        onChange={(e, v) => {
                                            setFieldValue("emailUsers", v.map(item => item.id || item._id));
                                        }}
                                        placeholder="Select Email Users"
                                        disabled={disabled}
                                    />
                                    <div className="form-error">
                                        {touched.emailUsers && errors.emailUsers ? errors.emailUsers : null}
                                    </div>
                                </Grid>

                                {/* <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                                        Completed Date
                                    </Typography>
                                    <DatePicker
                                        value={values.completedDate}
                                        onChange={(v) => setFieldValue("completedDate", v)}
                                        placeholder="Select Completed Date"
                                        disabled={disabled}
                                    />
                                    <div className="form-error">
                                        {touched.completedDate && errors.completedDate
                                            ? errors.completedDate
                                            : null}
                                    </div>
                                </Grid> */}

                                {/* <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                                        Remarks
                                    </Typography>
                                    <Field
                                        as="textarea"
                                        name="remarks"
                                        className="InputField"
                                        placeholder="Enter Remarks"
                                        style={{ height: "80px", paddingTop: "10px" }}
                                        disabled={disabled}
                                    />
                                    <div className="form-error">
                                        {touched.remarks && errors.remarks ? errors.remarks : null}
                                    </div>
                                </Grid> */}

                                <Grid size={{ xs: 12 }} mt={2}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "20px",
                                        }}>
                                        <Button
                                            className="cancelButton"
                                            onClick={() => setOpenDrawer(false)}>
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="addButton"
                                            sx={{ display: formType === "view" ? "none" : "flex" }}>
                                            {formType === "edit" ? "Update" : "Save"}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Form>
                    </div>
                )}
            </Formik>
        </CrudModal>
    );
};

export default AddHrAndAdminWork;
